import { render, staticRenderFns } from "./orderData.vue?vue&type=template&id=f8f3fbfc&"
import script from "./orderData.vue?vue&type=script&lang=js&"
export * from "./orderData.vue?vue&type=script&lang=js&"
import style0 from "./orderData.vue?vue&type=style&index=0&id=f8f3fbfc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports